var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2933 9.52416C22.0833 10.3142 22.0833 11.5951 21.2933 12.3851C20.5033 13.1751 19.2224 13.1751 18.4324 12.3851C17.6423 11.5951 17.6423 10.3142 18.4324 9.52416C19.2224 8.73413 20.5033 8.73413 21.2933 9.52416",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7034 5.91236C15.9199 7.12884 15.9199 9.10115 14.7034 10.3176C13.4869 11.5341 11.5146 11.5341 10.2981 10.3176C9.08162 9.10116 9.08162 7.12885 10.2981 5.91236C11.5146 4.69588 13.4869 4.69588 14.7034 5.91236",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56871 9.52416C7.35874 10.3142 7.35874 11.5951 6.56871 12.3851C5.77868 13.1751 4.49779 13.1751 3.70776 12.3851C2.91773 11.5951 2.91773 10.3142 3.70776 9.52416C4.49779 8.73413 5.77868 8.73413 6.56871 9.52416",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5002 19.0008V17.9048C23.5002 16.5238 22.3812 15.4048 21.0002 15.4048H20.1992",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 19.0008V17.9048C1.5 16.5238 2.619 15.4048 4 15.4048H4.801",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8392 19.0004V17.3994C17.8392 15.4664 16.2722 13.8994 14.3392 13.8994H10.6602C8.72716 13.8994 7.16016 15.4664 7.16016 17.3994V19.0004",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.f7f7afd8b71080c15565fa3ca8cb98cf.svg";
export { ForwardRef as ReactComponent };